import Image from 'app/Components/Shared/Image/image';
import {ContentAreaProperty} from '@episerver/spa-core/Property';
import React, {useCallback, useEffect, useRef, useState} from 'react';
import HiddenStopAndStartButton from 'app/utilities/HiddenStopAndStartButton';
import {ImageProps} from 'app/utilities/ImageProps';

export type SliderItem = {relatedCategory: ContentAreaProperty; name: string; image: ImageProps; description: string};

type SliderProps = {
  items: SliderItem[];
};

const ContentSlider = ({items}: SliderProps) => {
  const [translateX, setTranslateX] = useState(0);
  const [numberOfClones, setNumberOfClones] = useState(0);
  const [swiperIsStop, setSwiperIsStop] = useState<Boolean>(false);
  const [swiperAutoPlay, setSwiperAutoPlay] = useState('Stop');

  const imagesRef = useRef<HTMLDivElement>(null);
  const scrollContent = useCallback(() => {
    setTranslateX((prev) => {
      if (prev <= (imagesRef.current?.offsetWidth ?? 0)) {
        return prev + 0.8;
      } else {
        return 0;
      }
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(scrollContent, 10);

    if (swiperIsStop) {
      clearInterval(interval);
      setSwiperAutoPlay('Start');
    }

    return () => {
      clearInterval(interval);
    };
  }, [scrollContent, swiperIsStop]);

  useEffect(() => {
    if (!imagesRef.current) return;

    if (window.innerWidth > imagesRef.current.offsetWidth) {
      setNumberOfClones(Math.ceil(window.innerWidth / imagesRef.current.offsetWidth) + 1);
    } else {
      setNumberOfClones(1);
    }
  }, []);
  const renderImages = items.map((item, i) => <Image key={i} {...item.image} alt={item.description} />);

  return (
    <div className='ContentSlider'>
      <div style={{transform: `translate3d(${translateX}px,0,0)`}} className='ContentSlider__slider'>
        <div className='ContentSlider__slider__images' ref={imagesRef}>
          {renderImages}
        </div>

        {Array(numberOfClones)
          .fill(0)
          .map((_, i) => (
            <div className='ContentSlider__slider__images' key={i}>
              {renderImages}
            </div>
          ))}
      </div>
      <HiddenStopAndStartButton className='' onClick={() => setSwiperIsStop((prevState) => !prevState)} swiperAutoPlay={swiperAutoPlay} />
    </div>
  );
};

export default ContentSlider;
